import React, {useContext} from "react";
import {connect} from "react-redux";

import JobEditPopupCartItem from "./JobEditPopupCartItem";
import UiSwitch from "../../PageLayout/UiSwitch";
import JobEditPopupContext from "./JobEditPopupContext";
import {getRenderJobCartItemsGroupObjects, updateCartItems} from "./jobEditPopupFunctions";


const JobEditPopupContent = (props) => {

  const {jobCartItems, jobEditPopupSearchText, jobEditPopupActiveQuoteIndex, dispatch} = props;

  const {iframeElement} = useContext(JobEditPopupContext);

  if (!jobCartItems.length) {
    return <div className="flex flex--center height-100">No job items found</div>
  }

  const allGroupToggle = (cartItems, isRemoved) => {
    updateCartItems(cartItems, jobCartItems, "isRemoved", isRemoved, dispatch, iframeElement)
  }

  return (
    <div className="">
      {getRenderJobCartItemsGroupObjects(jobCartItems, jobEditPopupActiveQuoteIndex, jobEditPopupSearchText)
        .map((groupObject, quoteIndex) => {

          const allRemoved = groupObject.cartItems.every(cartItem => cartItem.isRemoved);

          return (
            <div key={groupObject.groupName + quoteIndex} className="mb-25">
              <div className="p-05 bg-littlegray color-blue font--16 bold">
                <div className="border-box flex flex--center flex--start pr-05">
                  <UiSwitch onClick={() => allGroupToggle(groupObject.cartItems, !allRemoved)}
                            checked={!allRemoved}/>
                  <span className="pl-1">{groupObject.groupName}</span>
                </div>
              </div>
              <ul className="fix-ul grid job-board-edit-popup__grid bold font--14 color-textgray text-left">
                {groupObject.cartItems.map((jobCartItem) => {
                  return <JobEditPopupCartItem key={jobCartItem.id}
                                               jobCartItem={jobCartItem}/>
                })}
              </ul>
            </div>
          )
        })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {jobCartItems, jobEditPopupSearchText, jobEditPopupActiveQuoteIndex} = store.jobEditPopupState;
  return {
    jobCartItems,
    jobEditPopupSearchText,
    jobEditPopupActiveQuoteIndex,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch
});

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobEditPopupContent)
)
